import React, { createContext } from 'react';

// Drag and Drop Context Provider
type DragAndDropOptionsContextType = {
	enabled: boolean;
};

export const DragAndDropOptionsContext: React.Context<DragAndDropOptionsContextType> =
	createContext<DragAndDropOptionsContextType>({
		enabled: false,
	});

// Drag and Drop Provider Component
export type DragAndDropOptionsProviderProps = {
	children: React.ReactNode;
	enabled?: boolean;
};
export const DragAndDropOptionsProvider = ({
	children,
	enabled = false,
}: DragAndDropOptionsProviderProps): React.JSX.Element => {
	return (
		<DragAndDropOptionsContext.Provider value={{ enabled }}>
			{children}
		</DragAndDropOptionsContext.Provider>
	);
};
